import { PersonDetails } from '@app/person'
import Button from 'components/button/base/Button'
import Dialog from 'components/dialog/base/Dialog'
import { Form, Formik, FormikHelpers as FormikActions } from 'formik'
import {
    requestAllPeopleRevalidation,
    useRequestPersonInvitationResending
} from 'helpers/peopleHelpers'
import { useGlobal } from 'hooks/useGlobal'
import React from 'react'
import { Trans, WithTranslation, withTranslation } from 'react-i18next'
import { compose } from 'recompose'

interface OwnProps {
    user: PersonDetails
}

type Props = OwnProps & WithTranslation

const ResendInvitationDialog: React.FC<Props> = (props: Props) => {
    const initialValues = {}

    const { t, user } = props

    const {
        createNotification,
        closeActiveOverlay,
        tryCloseDirtyOverlay
    } = useGlobal()

    const requestPersonInvitationResending = useRequestPersonInvitationResending()
    const onSubmit = async (
        values: unknown,
        formikActions: FormikActions<unknown>
    ) => {
        try {
            await requestPersonInvitationResending(user.id)
            requestAllPeopleRevalidation()
            closeActiveOverlay()
        } catch (payload) {
            // TODO: Introduce logging
            formikActions.setSubmitting(false)

            createNotification({
                type: props.t('error:labels.error'),
                description: props.t('error:response.resendInvitationUnknown')
            })
        }
    }

    return (
        <Dialog
            title={t('people:resendInvitation.title')}
            closeDialog={tryCloseDirtyOverlay}
            showCloseIcon={false}
        >
            <Formik initialValues={initialValues} onSubmit={onSubmit}>
                {(formikProps) => (
                    <Form className="dialog__form dialog__form--confirm">
                        <div className="dialog__info">
                            <Trans i18nKey="people:resendInvitation.question">
                                <strong>{{ username: user.name }}</strong>
                            </Trans>
                        </div>

                        <div className="dialog__actions dialog__actions--noShadow">
                            <Button
                                title={t('common:labels.cancel')}
                                onClick={closeActiveOverlay}
                                formButton
                            />

                            <Button
                                title={t('common:labels.resend')}
                                type="submit"
                                loading={formikProps.isSubmitting}
                                primary
                                formButton
                                autoFocus
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )
}

export default compose<Props, OwnProps>(
    withTranslation(['common', 'people', 'error'])
)(ResendInvitationDialog)
